import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { CelumPropertiesProvider } from '@celum/core/configuration';

/**
 * Service that sets the current B2C access token as a secure, httpOnly cookie
 * Note: Because of the secure nature of such cookies (Javascript has no access to them what-so-ever), the service can
 * only "guess" whether is has a valid cookie set or not. Outside of an httpError when requesting to set the cookie via
 * the endpoint, there is no mechanism to detect whether a cookie has e.g. expired.
 */
@Injectable({
  providedIn: 'root'
})
export class SecureCookieService {
  private http = inject(HttpClient);
  private accessToken: string;

  public setSecureTokenCookie(accessToken: string): void {
    if (!accessToken || this.accessToken === accessToken) {
      return;
    }

    this.updateToken(accessToken);
  }

  private updateToken(accessToken: string): void {
    console.debug('SecureCookieService: New token, requesting secure cookie from service');
    this.accessToken = accessToken;

    this.http.get<void>(`${CelumPropertiesProvider.properties.authentication.saccUrl}/cookie-token`, { withCredentials: true }).subscribe({
      error: error => {
        console.error(error);
        if (this.accessToken === accessToken) {
          this.accessToken = undefined;
        }
      }
    });
  }
}
